import { Flex, Text } from '@chakra-ui/react'
import React from 'react'

const NotFound = () => {
    return (
        <Flex p="40px" w="full" justify="center">
            <Text>Page Not Found!</Text>
        </Flex>
    )
}

export default NotFound
